import React from 'react';
import { useNuPlayerContext } from '../NuPlayerContext';

export const TrackInfo = ({ onClick }) => {
  const { currentTrack } = useNuPlayerContext();

  return (
    <div className="npTrackInfo" onClick={onClick}>
        <img src={currentTrack.thumbnail} alt={currentTrack.title} />
    </div>
  );
};
